import { Observable } from 'rxjs';
import { ICustomer } from './customer.interface';
import { Customer } from '@core/models/customer/customer.model';

export abstract class ICustomerSource {

  abstract createCustomer(customer: Customer): Observable<ICustomer>;
  abstract updateCustomer(customer: Customer): Observable<ICustomer>;

}
